<template>
	<v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-bind="$attrs" v-model="openModal" max-width="600px">
		<v-card >
			<v-toolbar dark color="primary">
				<v-toolbar-title>

					<h1><slot name="header"></slot></h1>

				</v-toolbar-title>
				<img height="100%" src="/assets/cadnet.jpeg">


				<v-spacer></v-spacer>
				<v-btn icon dark @click="openModal = false">
					<v-icon>close</v-icon>
				</v-btn>

			</v-toolbar>
			<v-card-title primary-title>

			</v-card-title>
			<v-card-text >
				<slot></slot>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<slot name="action"></slot>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "full-screen-dialog",
		props: ["value"],
		components: {},
		data() {
			return {};
		},
		computed: {
			openModal: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		}
	};
</script>

